






























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import CreateCaseLabel from "./create-case-label.vue";
import PrintCaseLabels from "./print-case-label.vue";
class PageCaseLabelRequest extends PageRequest {
  keyword: string;
  statusCode: string;
  fromDate: Date;
  toDate: Date;
}

@Component({
  components: {
    "create-case-label": CreateCaseLabel,
    "print-case-labels": PrintCaseLabels,
  },
})
export default class CaseLabel extends mixins(ListMixin, AbpBase) {
  namespace = "caseLabel";
  statuses = [];
  createModalShow: boolean = false;
  printModalShow: boolean = false;
  pagerequest: PageCaseLabelRequest = new PageCaseLabelRequest();
  creationTime: Date[] = [];
  selectedItems = [];
  pageTitlePopup: string = "printer";
  get store() {
    return this.$store.state.caseLabel;
  }
  get items() {
    return this.store.items;
  }
  pageChange(page: number) {
    this.$store.commit(`${this.namespace}/setCurrentPage`, page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit(`${this.namespace}/setPageSize`, pagesize);
    this.getpage();
  }
  preGetPage() {
    if (this.creationTime.length > 0) {
      this.pagerequest.fromDate = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.toDate = this.creationTime[1];
    }
  }
  async getStatuses() {
    await this.$store
      .dispatch({
        type: `${this.namespace}/getListStatusesForSelect`,
      })
      .then(() => {
        var re = this.store.statuses;
        re.splice(0, 0, { code: "_ALL", description: "Tất cả" });
        this.pagerequest.statusCode = re[0].code;
        this.statuses = re;
      });
  }
  async exportToExcel() {
    this.preGetPage();
    await this.$store.dispatch({
      type: `${this.namespace}/exportCaseLabels`,
      data: this.pagerequest,
    });
  }
  create() {
    this.createModalShow = true;
  }
  print() {
    this.printModalShow = true;
  }
  onSelect(selection, row) {
    this.$emit("on-select", selection, row);
  }
  onSelectCancel(selection, row) {
    this.$emit("on-select-cancel", selection, row);
  }
  onSelectAll(selection) {
    this.$emit("on-select-all", selection);
    _.forEach(this.list, (o) => {
      o._checked = true;
    });
    this.selectedItems = this.list;
  }
  onSelectionChange(selection) {
    this.$emit("on-selection-change", selection);
    _.forEach(this.list, (o) => {
      var itemSelected = _.find(selection, function (x) {
        return x.id === o.id;
      });
      if (itemSelected) {
        o._checked = true;
      } else {
        o._checked = false;
      }
    });
    this.selectedItems = this.list.filter((item) => item._checked);
  }
  get selectedBarcodes() {
    return _.map(this.selectedItems, "id");
  }

  onCancelPopupPrinter() {
    this.printModalShow = false;
  }

  onDownloadFilePrinter() {
    this.printModalShow = false;
    this.getpage();
  }

  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
      key: "_checked",
    },
    {
      title: Util.L("CaseLabelCode"),
      width: 200,
      key: "id",
    },
    {
      title: Util.L("Status"),
      width: 150,
      key: "statusName",
    },
    {
      title: Util.L("SKU"),
      width: 200,
      key: "sku",
    },
    {
      title: Util.L("ProductName"),
      width: 200,
      key: "productName",
    },
    {
      title: Util.L("Warehouse"),
      width: 100,
      key: "warehouseName",
      render: (h: any, params: any) => {
        return Util.isNull(params.row.warehouseName) ||
          Util.isEmpty(params.row.warehouseName)
          ? ""
          : h(
              "span",
              `${params.row.warehouseCode} - ${params.row.warehouseName}`
            );
      },
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
  ];
  async created() {
    await this.getStatuses();
  }
}
